import React from 'react';

import Checkbox from '@mui/material/Checkbox';

import ExpandableCard from 'components/ExpandableCard';
import SPayeeField from 'components/SPayeeField';

import { useField } from 'app-components/flux/transaction-rules/transactionRulesFormHooks';

import useStyles from '../styles';

function PayeeTarget() {
  const { classes } = useStyles();
  const { value, onValueChange, error, helperText } = useField('payeeTarget');

  return (
    <SPayeeField
      id='rule-payee-target'
      defaultValue={value}
      onChange={onValueChange}
      popupIcon={null}
      className={classes.payeeFieldContainer}
      textFieldProps={{
        label: undefined,
        placeholder: 'Rename as',
        error: error,
        helperText: helperText,
      }}
    />
  );
}

export function PayeeTargetCard(props: any) {
  const { classes, theme } = useStyles();
  const { value, onValueChange } = useField('isEnabledPayeeTarget');

  return (
    <ExpandableCard
      id='rule-payee-target'
      className={classes.card}
      title='Rename Payee'
      cardHeaderProps={{ padding: `${theme.spacing(1.5)} ${theme.spacing(2)}` }}
      titleProps={{ variant: 'subtitle2' }}
      expandIcon={
        <Checkbox id='rule-payee-target-enabled' checked={value} onChange={(_, checked) => onValueChange(checked)} />
      }
      isExpanded={value || !!props.hideToggle}
      hideToggle={!!props.hideToggle}
      onExpandedChange={onValueChange}
    >
      <PayeeTarget />
    </ExpandableCard>
  );
}
